module.exports = __webpack_public_path__ + "static/media/KIT HIDRONEUMATICOSYDQ.a3a3051f.pdf";